import { Button, Typography } from '@mui/material'
import { ActivityButton } from 'components/ActivityButton'
import { Modal } from 'components/Modal/Modal'
import { ModalFullBody } from 'components/Modal/ModalFullBody'
import { ModalFullFooter } from 'components/Modal/ModalFullFooter'
import { ModalFullHeader } from 'components/Modal/ModalFullHeader'
import { colors } from 'components/ThemeProvider'
import { usePutRewardsProgram } from 'hooks/api/usePutRewardsProgram'
import { useLayout } from 'hooks/useLayout'
import { type RewardsProgram, type LicensedEstablishment } from 'types/api'

export const EditLicensedEstablishmentHiddenStatus = ({
  licensedEstablishment,
  locationRewardsPrograms,
  isModalOpen,
  updateIsHidden,
  toggleModalIsOpen,
  onSubmitLicensedEstablishment,
}: {
  licensedEstablishment: LicensedEstablishment
  locationRewardsPrograms: RewardsProgram[]
  isModalOpen: boolean
  updateIsHidden: boolean
  toggleModalIsOpen: () => void
  onSubmitLicensedEstablishment: (
    licensedEstablishment: LicensedEstablishment
  ) => void
}) => {
  const { isMobile } = useLayout()
  const heightModal = isMobile ? '100%' : 'auto'
  const putRewardsProgramMutation = usePutRewardsProgram({})

  const onChangeStatus = () => {
    // Show/Hide LE
    onSubmitLicensedEstablishment({
      ...licensedEstablishment,
      hidden: !licensedEstablishment.hidden,
    })

    // Show/Hide associated RPs
    locationRewardsPrograms.forEach((rewardsProgram: RewardsProgram) => {
      putRewardsProgramMutation.mutate({
        id: rewardsProgram.id,
        rewardsProgramData: {
          name: String(rewardsProgram.name),
          description: String(rewardsProgram.description),
          active: !licensedEstablishment.hidden,
          type: rewardsProgram.type,
          corporateAccountId: rewardsProgram.corporateAccountId,
          licensedEstablishmentId: rewardsProgram.licensedEstablishmentId,
        },
      })
    })
  }

  return (
    <Modal
      isOpen={isModalOpen}
      toggleIsOpen={toggleModalIsOpen}
      sx={{
        width: isMobile ? '100%' : '60%',
        height: 'auto',
      }}
    >
      <ModalFullHeader
        toggleIsOpen={toggleModalIsOpen}
        title={`${
          licensedEstablishment.hidden ? 'Show' : 'Hide'
        } Licensed Establishment`}
        subTitle={`Name: ${licensedEstablishment.standardName}`}
        subTitle2={`ID: ${licensedEstablishment.id}`}
      />
      <ModalFullBody heightModal={heightModal}>
        <div className="flex flex-col text-center py-8">
          <Typography variant="h4">
            {`Are you sure you want to ${
              licensedEstablishment.hidden ? 'show' : 'hide'
            } the Licensed Establishment for ${
              licensedEstablishment.standardName
            }?`}
          </Typography>
          <Typography
            variant="body-1"
            color={colors.text.secondary}
            marginTop={2}
          >
            {`Doing this will ${
              licensedEstablishment.hidden ? 'show' : 'hide'
            } the Licensed Establishment in the Player PAYBACK app.`}
          </Typography>
        </div>
      </ModalFullBody>
      <ModalFullFooter>
        <Button onClick={toggleModalIsOpen}>Cancel</Button>
        <ActivityButton
          active={updateIsHidden}
          type="submit"
          variant="contained"
          onClick={onChangeStatus}
        >
          {licensedEstablishment.hidden
            ? 'Show Licensed Establishment'
            : 'Hide Licensed Establishment'}
        </ActivityButton>
      </ModalFullFooter>
    </Modal>
  )
}
